export function vehicleState(state) {
  let text = ""
  switch (state) {
    case 1:
      text = "启动"
      break;
    case 2:
      text = "熄火"
      break;
    case 3:
      text = "其他状态"
      break;
    default:
      text = "-"
      break;
  }
  return text
}
export function autoVehicleState() {
  let text = ""
  switch (state) {
    case 1:
      text = "启动"
      break;
    case 2:
      text = "熄火"
      break;
    case 3:
      text = "其他状态"
      break;
    default:
      text = "-"
      break;
  }
  return text
}
export function level(value) {
  if (value) {
    return dynamicData.level[value]

  } else {
    return "-"
  }
}

// 状态数据清单
const dynamicData = {
  autoCycleType:{
    '1' :'目标物数据',
    '2' :'位置数据',
    '3' :'决策数据',
    '4' :'整车性能数据',
    '5' :'感知系统数据',
    '6' :'道路信息数据',
    '7' :'自然环境数据',
    '8' :'整车状态数据',
    '9' :'人员数据',
    '10' :'部件数据',

    '11' :'整车数据',
    '12' :'驱动电机数据',
    '13' :'燃料电池数据',
    '14' :'发动机数据',
    '15' :'车辆位置数据',
    '16' :'极值数据',
    '17' :'报警数据',
    '18' :'拓展数据',
  },
  autoCycleTypeCode:{
    '1' :'TARGETDATA',
    '2' :'POSITIONDATA',
    '3' :'DECISIONDATA',
    '4' :'VEHICLEPERFORMANCEDATA',
    '5' :'PERCEPTIONDATA',
    '6' :'ROADINFODATA',
    '7' :'NATURALENVDATA',
    '8' :'VEHICLESTATUSDATA',
    '9' :'DRIVERDATA',
    '10' :'CONPONENTDATA',

    '11' :'VEHICLE',
    '12' :'MOTOR',
    '13' :'FUELCELL',
    '14' :'ENGINE',
    '15' :'CARPOSITION',
    '16' :'EXTREME',
    '17' :'ALARM',
    '18' :'EXTEMP',
  },

  eventTypeCode:{
    '1' :'COLLISIONEVENTDATA',
    '2' :'FAULTEVENTDATA',
    '3' :'OTAEVENTDATA',
    '4' :'ADEVENTDATA',
    '5' :'REMOTECONTROLEVENTDATA',
    '6' :'ADASEVENTDATA',
  },
  // 车辆状态
  vehicleState: {
    '1': '车辆启动状态',
    '2': '熄火',
    '3': '其他状态',
    '240': '异常',
    '256': '无效',
  },
  // 充电状态
  chargeState: {
    '1': '停车充电',
    '2': '行驶充电',
    '3': '未充电状态',
    '4': '充电完成',
    '240': '异常',
    '256': '无效',
  },
  // 运行模式
  mode: {
    '1': '纯电',
    '2': '混动',
    '3': '燃油',
    '240': '异常',
    '256': '无效',
  },
  // DC-DC状态
  dcDc: {
    '1': '工作',
    '2': '断开',
    '240': '异常',
    '256': '无效',
  },
  // 驱动电机状态
  stateHex: {
    '1': '耗电',
    '2': '发电',
    '3': '关闭状态',
    '4': '准备状态',
    '240': '异常',
    '256': '无效',
  },

  // 高压DC/DC状态
  fcDcDu: {
    '1': '工作',
    '2': '断开',
    '240': '异常',
    '256': '无效',
  },
  // 发动机状态
  state: {
    '1': '启动',
    '2': '关闭',
    '240': '异常',
    '256': '无效',
  },

  // 定位状态
  locationEW: {
    '0': '有效定位',
    '1': '无效定位'
  },

  // 最高报警等级
  level: {
    '0': '无故障',
    '1': '1级故障',
    '2': '2级故障',
    '3': '3级故障',
    '254': '异常',
    '255': '无效',
  },
  // 通用报警标志
  tempAlarm: {
    '0': '正常',
    '1': '温度差异报警'
  },
  batteryAlarm: {
    '0': '正常',
    '1': '电池高温报警'
  },
  dhighPreAlarm: {
    '0': '正常',
    '1': '车载储能装置类型过压报警'
  },
  dlowPreAlarm: {
    '0': '正常',
    '1': '车载储能装置类型欠压报警'
  },
  lowSocAlarm: {
    '0': '正常',
    '1': 'SOC低报警'
  },
  bhighPreAlarm: {
    '0': '正常',
    '1': '单体电池过压报警'
  },
  blowPreAlarm: {
    '0': '正常',
    '1': '单体电池欠压报警'
  },
  hishSocAlarm: {
    '0': '正常',
    '1': 'SOC过高报警'
  },
  hopSocAlarm: {
    '0': '正常',
    '1': 'soc跳变报警'
  },
  dmissAlarm: {
    '0': '正常',
    '1': '可充电储能系统不匹配报警'
  },
  duniAlarm: {
    '0': '正常',
    '1': '电池单体一致性差报警'
  },
  isolateAlarm: {
    '0': '正常',
    '1': '绝缘报警'
  },
  dcHighTempAlarm: {
    '0': '正常',
    '1': 'DC-DC温度报警'
  },
  brakeAlarm: {
    '0': '正常',
    '1': '制动系统报警'
  },
  dcStatusAlarm: {
    '0': '正常',
    '1': 'DC-DC状态报警'
  },
  etempAlarm: {
    '0': '正常',
    '1': '驱动电机控制器温度报警'
  },
  lockAlarm: {
    '0': '正常',
    '1': '高压互锁状态报警'
  },
  driveTempAlarm: {
    '0': '正常',
    '1': '驱动电机温度报警'
  },
  chargeAlarm: {
    '0': '正常',
    '1': '车载储能装置类型过充'
  },
  validate: {
    true: '有效',
    false: '无效'
  },
  stalls: {
    '0': '空档',
    '1': '1档',
    '2': '2档',
    '3': '3档',
    '4': '4档',
    '5': '5档',
    '6': '6档',
    '7': '7档',
    '8': '8档',
    '9': '9档',
    '10': '10档',
    '11': '11档',
    '12': '12档',
    '13': '倒档',
    '14': '自动D档',
    '15': '停车P档',
  },
  exTemp: {
    '214': "异常",
    '215': "无效",
  },
  exEVoltage: {
    '6553.4': "异常",
    '6553.5': "无效",
  },
  exECurrent: {
    '5553.4': "异常",
    '5553.5': "无效",
  },
  exHVoltage: {
    '6553.4': "异常",
    '6553.5': "无效",
  },
  exHCurrent: {
    '5553.4': "异常",
    '5553.5': "无效",
  }
}

/**
 * 格式化状态
 * @param key 需要格式化的key
 * @param value 需要格式化的value
 */
export function formatStatus(key, value, unit) {
  return dynamicData[key] ? (dataKeyValue(dynamicData[key][value], value, unit) || '一') : '一'
}

// dataKey不存在，判断是否有值，有值显示值，无值return
function dataKeyValue(formatValue, value, unit) {
  if (formatValue) {
    return formatValue
  } else {
    if (value) {
      return value + (unit ? unit : '');
    } else {
      return ""
    }
  }
}
